import React from "react";
import { logo } from "environment";

const Logo = ({ className }) => {
  return (
    <a className={className} href="https://www.careerpuck.com/">
      <img src={logo} width="70" height="24.25" alt="Puck home" />
    </a>
  );
};

export default Logo;
